import { ArrowRightIcon } from "@radix-ui/react-icons";

import { cn } from "./../../lib/utils";
import { Button } from "./button";
import AnimatedGridPattern from "./animated-grid-pattern";
import BoxReveal from "./box-reveal";

const BentoGrid = ({ children, className }) => {
  return <div className={cn("grid w-full auto-rows-[22rem] grid-cols-3 gap-4", className)}>{children}</div>;
};

const BentoCard = ({ languageProvider, name, className, background, Icon, description, onClick, cta, fullDes }) => (
  <div
    key={name}
    className={cn(
      "group relative col-span-3 flex flex-col justify-between overflow-hidden rounded-xl",
      // light styles
      "bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]",
      // dark styles
      "transform-gpu dark:bg-black dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]",
      className
    )}
  >
    <div>{background}</div>

    <div className="pointer-events-none z-10 flex transform-gpu flex-col gap-1 p-4 transition-all duration-300 group-hover:-translate-y-10">
      <Icon className="h-12 w-12 origin-left transform-gpu text-neutral-700 transition-all duration-300 ease-in-out group-hover:scale-75" />
      <h3 className="text-xl font-semibold text-neutral-700 dark:text-neutral-300">{languageProvider.getText(name)}</h3>
      <BoxReveal className="flex w-full" boxColor={"#5046e6"} duration={0.5}>
        <p className="max-w-lg text-neutral-400">{languageProvider.getText(description)}</p>
      </BoxReveal>
      <AnimatedGridPattern
        numSquares={30}
        maxOpacity={0.1}
        duration={3}
        repeatDelay={1}
        className={cn(
          "[mask-image:radial-gradient(500px_circle_at_center,white,transparent)]",
          "inset-x-0 inset-y-[-30%] h-[200%] skew-y-12"
        )}
      />
    </div>

    <div
      className={cn(
        "pointer-events-none absolute bottom-0 flex w-full translate-y-10 transform-gpu flex-row items-center p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100"
      )}
    >
      <Button
        onClick={() => {
          onClick(fullDes);
        }}
        variant="rainbow"
        asChild
        size="sm"
        className="pointer-events-auto"
      >
        <div>
          {languageProvider.getText(cta)}
          <ArrowRightIcon className="ml-2 h-4 w-4" />
        </div>
      </Button>
    </div>
    <div className="pointer-events-none absolute inset-0 transform-gpu transition-all duration-300 group-hover:bg-black/[.03] group-hover:dark:bg-neutral-800/10" />
  </div>
);

export { BentoCard, BentoGrid };
